import React, { useEffect, useState } from "react";
import { useAllCommunities, useCommunityHistory } from "./store";
import { Button, Tab, Tabs } from "react-bootstrap";
import CardDiv from "modules/common/card-div/CardDiv";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import AddCommunity from "modules/traya_community/AddCommunity";
import BulkAddOrder from "modules/traya_community/BulkAddOrder";
import { fourPlaceHolder, removeSpaces } from "modules/utilities/utility";
import CommunityTable from "modules/traya_community/CommunityTable";
import CommunityHistoryTable from "modules/traya_community/CommunityHistoryTable";
import NoData from "assets/svgs/no_data/NoData";
import { CommunityEngagement } from "./CommunityEngagements";

function Community() {
  const { communityData, isLoading, fetchAllCommunities } = useAllCommunities();
  const { communityHistoryData, historyLoading, fetchCommunityHistoryData } =
    useCommunityHistory();

  useEffect(() => {
    fetchAllCommunities();
  }, []);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const handleClear = () => {
    setStartDate(null);
    setEndDate(null);
  };


  const handleSubmit = () => {
    const sd = moment(startDate).format("YYYY-MM-DD");
    const ed = moment(endDate).format("YYYY-MM-DD");
    fetchCommunityHistoryData(sd, ed);
  };

  return (
    <div className="">
      <Tabs
        variant="pills"
        defaultActiveKey="trayacommunity"
        id="uncontrolled-tab-example"
        className="mb-2 border-bottom pb-2"
      >
        <Tab eventKey="trayacommunity" title="Traya Community">
          <CardDiv
            title={
              <div className="d-flex my-n2 align-items-center">
                <div className="flex-fill fs-1">Community</div>
                <div className="d-flex px-2 gap-2">
                  <AddCommunity />
                  <BulkAddOrder communityData={communityData} />
                </div>
              </div>
            }
            component={
              <div className="card p-3">
                {isLoading ? (
                  fourPlaceHolder()
                ) : communityData?.length ? (
                  <CommunityTable data={communityData} />
                ) : (
                  <div className="text-center border rounded p-2">
                    No Data Available <NoData />
                  </div>
                )}
              </div>
            }
          />
        </Tab>
        <Tab eventKey="community-history" title="Community History">
          <CardDiv
            title={
              <div className="d-flex justify-content-between my-n2 align-items-center">
                <div className="fs-1">Community History</div>
                <div className="w-50 d-flex gap-2">
                  <ReactDatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    formatWeekDay={(day) => day.slice(0, 3)}
                    className="form-control"
                    placeholderText="Start Date"
                  />
                  <ReactDatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    formatWeekDay={(day) => day.slice(0, 3)}
                    className="form-control"
                    placeholderText="End Date"
                  />
                  <Button
                    disabled={!startDate || !endDate}
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                  <Button onClick={handleClear}>Clear</Button>
                </div>
              </div>
            }
            component={
              <div className="card p-2">
                {historyLoading ? (
                  fourPlaceHolder()
                ) : communityHistoryData?.length ? (
                  <CommunityHistoryTable data={communityHistoryData} />
                ) : (
                  <div className="text-center border p-2 rounded">
                    Data is not available <NoData />
                  </div>
                )}
              </div>
            }
          />
        </Tab>
        <Tab eventKey="engagements" title="Engagements">
          <CardDiv
              title={
                <div className="d-flex justify-content-between my-n2 align-items-center">
                  <div className="fs-1">Engagements</div>
                </div>
              }
              component={
                <CommunityEngagement />
              }
          />
        </Tab>
      </Tabs>
    </div>
  );
}

export default Community;
